export default __webpack_public_path__ + "static/media/whyChoseIcon.f59d162a.svg";